'use client';
import React, { useState, useEffect, useRef } from 'react';
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
import mqtt from 'mqtt';
import { useUserContext } from '../contexts/UserContext';

let signalstopic = 'goldensparrowcapital-signals';
const Zscores = props => { 
  const {
    user
   } = useUserContext();

   const [zscores, setZscores] = useState([]);
     const [client, setClient] = useState(null);
     const mqttClientRef = useRef(null); // this will prevent receving the subscribed message multiple times
     const wsRefBinance = useRef(null);
     const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

   //connect and subscribe to MQTT broker
    const _connectMQTT = async props => {
      let now = new Date().valueOf();
      if (!client) {
        let clientID = 'GoldenSparrowCapital-' + Math.random().toString(16).substring(2, 8);
        const gsccookie = Cookies.get('gsccookie') || null;
        const newClient = mqtt.connect(process.env.REACT_APP_EXTERNAL_MQTT_SERVER_URL, {
          clientId: clientID,
          username: 'user-jwt',
          password: gsccookie,
          clean: true,
          rejectUnauthorized: true,
          reconnectPeriod: 60000,
        });
        mqttClientRef.current = newClient;
        newClient.on('connect', async () => {
          console.log('Connected to MQTT:', new Date().toLocaleTimeString());
    
          newClient.subscribe('RECEIVE_ZSCORES', err => {
            if (!err) {
              console.log('Topic subscribed:RECEIVE_ZSCORES');
            } else {
              console.error('Topic Subscribe error', err);
            }
          });
           newClient.publish('GET_ZSCORES', JSON.stringify({ token: gsccookie }), err => {
            if (!err) {
              console.log('GET_ZSCORES request published:', new Date().toLocaleTimeString());
            } else {
              console.error('Topic Publish error', err);
            }
          });
    
          // Register the message handler only once, after connection
          newClient.on('message', (topic, message) => {
            if (topic == 'RECEIVE_ZSCORES') {
              let raw = JSON.parse(message);
              setZscores(raw.zscores);
              setLastUpdated(new Date().valueOf());
            }
          });
    
         
    
        });
    
        setClient(newClient);
      }
    };
    // Remove the client.on('message', ...) from this effect
    // useEffect(() => {
    //   return () => {
    //     if (client) {
    //       if (mqttClientRef.current) {
    //         console.log('Disconnecting...', new Date().toLocaleTimeString());
    //         mqttClientRef.current.end(); // Disconnect properly
    //         setClient(null);
    //       }
    //     }
    //   };
    // }, [client]);
  
    useEffect(() => {
      async function fetchData() {
        if (user.userType == "ADMIN") {
          await _connectMQTT(props);
        }
      }
      fetchData();
    }, []);




  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  async function handleDelete(symbol) {
    // console.log("Deleting PreWatcher:", uuid)
    const gsccookie = Cookies.get('gsccookie') || null;
    console.log("Deleting Zscore:", symbol, gsccookie)

   
  }


  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <div className="flex">
          <main className="flex-1 p-0">
            <header className="mb-6">
              <h1 className="text-2xl font-bold">Z-Scores ({zscores.length}) </h1>
              {/* <h1 className="text-xs" style={{ margin: 0, paddingTop: 5, color: 'gray' }}>{user?.email }</h1>
              <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray' }}>{'Subscription until: ' + new Date(user?.subscriptionFreeUntil).toLocaleString(undefined, { hour12: true })}</h1> */}

            </header>
  <div style={{ borderRadius: 8, width: 'auto' }}>
      <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray', marginBottom: 3 }}>
          Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
          {new Date(lastUpdated).toLocaleTimeString()}
        </h1>
         {zscores.length > 0 ? (
                  <div style={{ padding: 5 }}>
                    <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
                      <thead>
                        <tr>
                          <th className="text-sm py-2 px-4 border-b">S.No.</th>
                          <th className="text-sm py-2 px-4 border-b">Updated Date & Time</th>
                          <th className="text-sm py-2 px-4 border-b">Symbol</th>
                          <th className="text-sm py-2 px-4 border-b">Candles</th>
                          <th className="text-sm py-2 px-4 border-b">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {_.orderBy(
                          zscores,
                          'lastUpdated',
                          'desc'
                        ).map((zscore, index) => {
                          return (
                            <tr key={index}>
                              <td className="text-xs py-2 px-4 border-b text-center">
                                {index + 1}.
                              </td>
                              <td className="py-2 px-4 border-b text-center">
                                {new Date(zscore.lastUpdated).toLocaleDateString()} {new Date(zscore.lastUpdated).toLocaleTimeString()}
                              </td>
                              <td className="py-2 px-4 border-b text-center">
                                <button
                                  key={index}
                                  style={{
                                    backgroundColor: 'grey',
                                    fontSize: 12,
                                    borderRadius: 5,
                                    padding: 5,
                                    margin: 2
                                  }}
                                  onClick={() =>
                                    window.open(
                                      'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + zscore.symbol,
                                      '_blank'
                                    )
                                  }
                                >
                                  <div style={{ alignItems: 'center', display: 'flex' }}>
                                    <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{zscore.symbol} ({zscore.zscoreCount})</h4>
                                  </div>
                                </button>
                              </td>
                              <td className="py-2 px-4 border-b text-center">
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: 2 }}>
                                {_.orderBy(
                          zscore.candles,
                          'timestamp',
                          'asc'
                        ).map((candle, ii) => (
                                  <div key={ii} color={candle.color} style={{ padding:3, borderRadius : 3, backgroundColor: candle.color }}>
                              {`${Math.floor((Date.now() - candle.timestamp) / 60000)}`}
                                  </div>
                                ))}
                                </div>
                              </td>
                              <td className="text-center border-b">
                                <button
                                  style={{ backgroundColor: "red", borderRadius: 5, padding: 5, fontSize: 12 }}
                                  onClick={() => handleDelete(zscore.symbol)}
                                  className="text-white-500 hover:text-white-800"
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  null
                )}
  </div>
       
       
         
        </main>
      </div>
    </div>
  );
};

export default Zscores;
